<div class="agent-tasks">
  <div class="header">
    <h2>Agent Tasks</h2>
    <span class="total-count" *ngIf="!loading">{{ totalCount }} tasks</span>
  </div>

  <div class="filters">
    <div class="filter-group">
      <label>Database:</label>
      <select [(ngModel)]="selectedDatabase" (change)="onFilterChange()">
        <option value="">All Databases</option>
        <option *ngFor="let db of databases" [value]="db">{{ db }}</option>
      </select>
    </div>

    <div class="filter-group">
      <label>Role:</label>
      <select [(ngModel)]="selectedRoleId" (change)="onFilterChange()">
        <option [ngValue]="null">All Roles</option>
        <option *ngFor="let role of roleTypes" [ngValue]="role.roleTypeID">
          {{ role.roleTypeName }}
        </option>
      </select>
    </div>

    <div class="filter-group">
      <label>Status:</label>
      <select [(ngModel)]="selectedStatus" (change)="onFilterChange()">
        <option *ngFor="let opt of statusOptions" [ngValue]="opt.value">{{ opt.label }}</option>
      </select>
    </div>
  </div>

  <div *ngIf="error" class="error-message">{{ error }}</div>
  <div *ngIf="loading" class="loading">Loading...</div>

  <div *ngIf="!loading && tasks.length === 0 && !error" class="no-data">
    No agent tasks found
  </div>

  <table *ngIf="!loading && tasks.length > 0" class="data-table">
    <thead>
      <tr>
        <th>#</th>
        <th>Database</th>
        <th>Version</th>
        <th>Role</th>
        <th>Status</th>
        <th>Publish</th>
        <th>Created</th>
        <th>Started</th>
        <th>Completed</th>
        <th>Error</th>
        <th>Log</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let task of tasks">
        <td>{{ task.taskID }}</td>
        <td>{{ task.dbID }}</td>
        <td>{{ task.versionName || '—' }}</td>
        <td>{{ task.roleID }}</td>
        <td>
          <span class="task-status" [ngClass]="getStatusClass(task.status)">
            {{ getStatusLabel(task.status) }}
          </span>
        </td>
        <td>
          <span class="publish-status" [ngClass]="task.publishStatus === 100 ? 'status-success' : task.publishStatus === 99 ? 'status-error' : ''">
            {{ getPublishLabel(task.publishStatus) }}
          </span>
        </td>
        <td>{{ task.createdDate | date:'dd/MM/yy HH:mm' }}</td>
        <td>{{ task.startedDate ? (task.startedDate | date:'dd/MM/yy HH:mm') : '—' }}</td>
        <td>{{ task.completedDate ? (task.completedDate | date:'dd/MM/yy HH:mm') : '—' }}</td>
        <td class="error-cell" [title]="task.errorDesc || ''">
          {{ task.errorDesc ? (task.errorDesc.length > 40 ? task.errorDesc.slice(0, 40) + '…' : task.errorDesc) : '' }}
        </td>
        <td>
          <button *ngIf="task.outputFile" class="btn btn-sm btn-log" (click)="viewLog(task)">
            View Log
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="totalPages > 1" class="pagination">
    <button class="btn btn-sm" (click)="goToPage(1)" [disabled]="currentPage === 1">« First</button>
    <button class="btn btn-sm" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">‹ Prev</button>

    <span *ngFor="let page of getPageNumbers()">
      <button class="btn btn-sm" [class.active]="page === currentPage" (click)="goToPage(page)">{{ page }}</button>
    </span>

    <button class="btn btn-sm" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">Next ›</button>
    <button class="btn btn-sm" (click)="goToPage(totalPages)" [disabled]="currentPage === totalPages">Last »</button>

    <span class="page-info">Page {{ currentPage }} of {{ totalPages }} ({{ totalCount }} total)</span>
  </div>
</div>

<!-- Log Viewer Modal -->
<div class="log-modal-overlay" *ngIf="logModalVisible" (click)="closeLog()">
  <div class="log-modal" (click)="$event.stopPropagation()">
    <div class="log-modal-header">
      <h3>Task #{{ selectedTaskId }} — Output Log</h3>
      <button class="btn-close" (click)="closeLog()">✕</button>
    </div>
    <div class="log-modal-body">
      <div *ngIf="logLoading" class="loading">Loading log...</div>
      <div *ngIf="logError" class="error-message">{{ logError }}</div>
      <pre *ngIf="!logLoading && !logError" [innerHTML]="logHtml" class="log-output"></pre>
    </div>
  </div>
</div>
